/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';
import { TId } from '../../components/common/generic/tree/types';

export type TMethod<CR> = CR extends (state: any, ...args: infer Action) => any
  ? (id: TId, ...args: Action) => unknown
  : () => unknown;

export type TMethods<State extends TMap, K extends any[] = any[]> = Record<
  string,
  (setState: TStateManager<State>, ...args: K) => void
>;

export type TMethodsMap<OriginalMethods extends TMethods<any>> = {
  [Name in keyof OriginalMethods]: TMethod<OriginalMethods[Name]>;
};

export type TEventsMap<OriginalEvents extends TMap> = {
  [Name in keyof OriginalEvents]: (args: OriginalEvents[Name]) => unknown;
};

export type TEventsHandlers<OriginalEvents extends TMap> = Record<
  TId,
  {
    [Name in keyof OriginalEvents]?: ((
      args: OriginalEvents[Name],
    ) => unknown)[];
  }
>;

export type TMap = Record<string, any>;

export type TStateManager<State> = (newState: Partial<State>) => void;

export type TUseEvents<Events extends TMap> = (
  handlers: Partial<TEventsMap<Events>>,
) => void;

export const ImperativeComponentContext = createContext<{
  id: TId;
  eventsStore: TEventsHandlers<any>;
}>(
  {} as {
    id: TId;
    eventsStore: TEventsHandlers<any>;
  },
);

export type TFireEvent<Events extends TMap> = <K extends keyof Events>(
  id: TId,
  ev: K,
  args: Events[K],
) => void;
